import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@app/core/services';
import { User } from '@app/entity';
import { LockScrollService } from '@app/shared/lock-scroll.service';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit, OnDestroy {
  @Input() user: User;
  authorizedUserId: number;

  isScrollLocked: boolean;

  ngUnsubscribe = new Subject();

  constructor(
    private authService: AuthService,
    private lockScrollService: LockScrollService,
  ) {
    this.authService.userId
      .subscribe(id => this.authorizedUserId = id);
  }

  ngOnInit() {
    this.lockScrollService.isScrollLocked
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(isLocked => this.isScrollLocked = isLocked);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  logout() {
    if (confirm('Вы уверены, что хотите выйти из аккаунта?')) this.authService.logout();
  }
}



// WEBPACK FOOTER //
// ./src/app/accounts/user-info/user-info.component.ts